import {FC, Fragment, useState} from 'react'
import SequenceFieldShell from 'src/app/pages/listing/components/SequenceFieldShell'
import InfoTooltip from './InfoTooltip'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faPlus} from '@fortawesome/free-solid-svg-icons'
import {Button, OverlayTrigger, Tooltip} from 'react-bootstrap'
import CopyToClipboard from 'react-copy-to-clipboard'
import { useAppSelector } from 'src/redux/storeHooks'
import {useApplyPlatformSettingShortcodes} from 'src/utils/usePlatformSettingDisplayText'

const ShortCodeInput: FC<{
  inputProps: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
  label: string
  message: string
  inputWrapperClasses?: string
  containerClasses?: string
  labelClass?: string
  useSequenceBandLayout?: boolean
  sourceChannelName?: string | null
}> = ({
  inputProps,
  label = '',
  message = '',
  inputWrapperClasses = '',
  containerClasses = 'col-12 col-sm-6 mt-4',
  labelClass = `form-label ${inputProps?.required ? 'required' : ''}`,
  useSequenceBandLayout = false,
  sourceChannelName,
}) => {
  const formatSettingDisplayText = useApplyPlatformSettingShortcodes(sourceChannelName)
  const displayInputProps = {
    ...inputProps,
    ...(inputProps.placeholder != null
      ? {placeholder: formatSettingDisplayText(String(inputProps.placeholder))}
      : {}),
  }
  const [isShortCodeVisible, setIsShortCodeVisible] = useState(false)
  const [shortCode, setShortCode] = useState(['[ORDER_NUMBER]'])
  const [copyMarkup, setCopyMarkup] = useState<boolean>(false)
  const [buttonString, setButtonString] = useState('')
  const {mainStoreData} = useAppSelector((state) => state.fetchConnectedPlatform)
  const { retrivedPlatformData} = useAppSelector(
    (state) => state.retrivePlatformData
  )
  
  // const [field] = useField({name:inputProps.name!, type:inputProps.type })


const handleCopyMarkup = (data: string) => {
  navigator.clipboard.writeText(data)
  setCopyMarkup(true)
  setButtonString(data)

  setTimeout(() => {
    setCopyMarkup(false)
    setButtonString('')
  }, 1000)
}

  //   need to improve this currnetly this is only a fix
  const renderTooltip = (shortcode: string) => {
    let tooltipText = ''
    switch (shortcode) {
      case '[ORDER_ID]':
        tooltipText = ` ${mainStoreData?.code} Auto Generated`
        break
      case '[ORDER_NUMBER]':
        tooltipText = `Order Number from ${retrivedPlatformData?.code}`
        break
      default:
        tooltipText = ''
    }
    return <Tooltip id={`${shortcode}-tooltip`}>{tooltipText}</Tooltip>
  }

  const labelNode = (
    <label className={labelClass} htmlFor={inputProps.id}>
      {formatSettingDisplayText(label)} &nbsp;&nbsp;
      <InfoTooltip message={message} sourceChannelName={sourceChannelName} />
    </label>
  )

  const metaNode = (
    <div className='d-flex w-md-100 mt-1'>
        {/* <button
          type='button'
          className='btn text-muted text-hover-primary fw-bold mt-1 cursor-pointer'
          onClick={() => setIsShortCodeVisible(!isShortCodeVisible)} // Pass input identifier to handleShortCode}
        >
          <FontAwesomeIcon icon={faPlus} className='me-2' /> 
        </button> */}
        {/* {isShortCodeVisible && ( */}
        <span className='fs-6 fw-medium text-secondary mx-1 mt-1'>Available Shortcodes : </span>
        <div>
          {shortCode?.length &&
            shortCode.map((ele: string) => (
              <Fragment key={ele}>
                <OverlayTrigger placement='bottom' overlay={renderTooltip(ele)}>
                  <CopyToClipboard text={ele}>
                    <Button
                      key={ele}
                      size='sm'
                      variant={'outline-secondary'}
                     className={`px-2 py-1 m-1 border border-secondary rounded fs-sm-8 inline-block 
    ${copyMarkup && buttonString === ele 
      ? 'text-white bg-secondary hover:bg-secondary' 
      : 'text-secondary bg-white hover:bg-light'}
  `}
                      onClick={() => handleCopyMarkup(ele)}
                    >
                      {copyMarkup && buttonString === ele ? (
    <span className="fs-sm-8">Copied!</span>
  ) : (
    ele
  )}
                    </Button>
                  </CopyToClipboard>
                </OverlayTrigger>
              </Fragment>
            ))}
        </div>
        {/* )} */}
    </div>
  )

  if (useSequenceBandLayout) {
    return (
      <div className={containerClasses}>
        <SequenceFieldShell
          label={labelNode}
          control={
            <div className={inputWrapperClasses}>
              <input {...displayInputProps} />
            </div>
          }
          meta={metaNode}
        />
      </div>
    )
  }

  return (
    <div className={containerClasses} style={{paddingRight: '5.5rem'}}>
      {labelNode}
      <div className={inputWrapperClasses}>
        <input {...displayInputProps} />
      </div>
      {metaNode}
    </div>
  )
}

export default ShortCodeInput
